export default __webpack_public_path__ + "assets/andorra-flag.png";